<template>
  <section id="hero" class="hero-container">
    <div class="intro-text">
      <h1 class="code-font">&gt; Kim Tae-young</h1>
      <h2>
        I build <span class="highlight">{{ typedText }}</span>
      </h2>
      <p>문제 해결 과정을 즐기는 주니어 백엔드 개발자 김태영입니다.</p>
    </div>

    <div class="scroll-indicator">
      <div class="mouse">
        <div class="scroll-wheel"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      roles: ["APIs.", "Services.", "Backend Systems."],
      currentRoleIndex: 0,
      typedText: "",
      charIndex: 0,
      isDeleting: false,
    };
  },
  methods: {
    typeWriter() {
      const currentRole = this.roles[this.currentRoleIndex];
      if (this.isDeleting) {
        this.typedText = currentRole.substring(0, this.charIndex - 1);
        this.charIndex--;
      } else {
        this.typedText = currentRole.substring(0, this.charIndex + 1);
        this.charIndex++;
      }

      if (!this.isDeleting && this.charIndex === currentRole.length) {
        this.isDeleting = true;
        setTimeout(this.typeWriter, 2000);
      } else if (this.isDeleting && this.charIndex === 0) {
        this.isDeleting = false;
        this.currentRoleIndex = (this.currentRoleIndex + 1) % this.roles.length;
        setTimeout(this.typeWriter, 500);
      } else {
        setTimeout(this.typeWriter, this.isDeleting ? 100 : 200);
      }
    },
  },
  mounted() {
    this.typeWriter();
  },
};
</script>

<style scoped>
.hero-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: left;
  padding: 0 5%;
  position: relative;
  background-color: var(--bg-color);
}
.intro-text h1 {
  font-size: 2rem;
  color: var(--text-primary-color);
}
.intro-text h2 {
  font-size: 4rem;
  font-weight: 700;
  margin: 10px 0;
  color: var(--text-primary-color);
}
.intro-text p {
  font-size: 1.2rem;
  color: var(--text-secondary-color);
  max-width: 600px;
}
.highlight {
  color: var(--point-color);
}
.scroll-indicator {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
.mouse {
  width: 28px;
  height: 48px;
  border: 2px solid var(--text-secondary-color);
  border-radius: 14px;
}
.scroll-wheel {
  width: 4px;
  height: 8px;
  background-color: var(--text-secondary-color);
  border-radius: 2px;
  margin: 8px auto 0;
  animation: scroll 2s infinite;
}
@keyframes scroll {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(12px);
    opacity: 0.5;
  }
  100% {
    transform: translateY(24px);
    opacity: 0;
  }
}
@media (max-width: 768px) {
  .intro-text h1 {
    font-size: 1.5rem;
  }
  .intro-text h2 {
    font-size: 2.5rem;
  }
  .intro-text p {
    font-size: 1rem;
  }
  .hero-container {
    text-align: center; /* 모바일에서는 중앙 정렬 */
  }
}
</style>
